import { FeatureFlag } from "@vega-api/extended/auth/featureFlagEnum";
import { useNoUserFeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { useGetPublicLoginFaqs } from "@vega-api/generated/cms-faqs-public/cms-faqs-public";
import { type FAQItemType } from "@vega-core/models/faq.type";

import { buildFaqItemBodyHtml } from "../../HelpCentreCMS/utils/buildFaqItemBodyHtml";
import { filterEmptyFaqItems } from "../../HelpCentreCMS/utils/filterEmptyFaqItems";

export function useCmsLoginFaqs(fallback: FAQItemType[]): FAQItemType[] {
  const isFlagEnabled = useNoUserFeatureFlag(FeatureFlag.VEGA_CMS_MIGRATION);

  const { data } = useGetPublicLoginFaqs({
    query: {
      enabled: isFlagEnabled,
    },
    request: {
      skipInterceptors: true,
    },
  });

  if (!isFlagEnabled) {
    return fallback;
  }

  return (data?.data ?? []).flatMap((category) =>
    filterEmptyFaqItems(category.items).map((item, index) => ({
      id: `cms-login-faq-${category.id}-${index}`,
      title: item.question,
      body: buildFaqItemBodyHtml(item),
    })),
  );
}
